<template>
  <div class="home-banner">
    <mf-loading-dialog :loading="$apollo.queries.configuration.loading">
      <v-container class="pa-0" fluid>
        <v-card class="my-3 pa-1">
          <v-row align="center" justify="center" class="phone-row">
            <div class="configurar-banner">
              <v-flex xs12 md12>
                <div class="outer-frame-push">
                  <v-layout justify-center>
                    <v-flex xs4>
                      <v-layout>
                        <v-spacer />
                        <div class="camera-slot" />
                      </v-layout>
                    </v-flex>
                    <v-flex xs4 class="ear-speaker-slot" />
                    <v-flex xs4 />
                  </v-layout>
                  <div class="inner-frame-mobile">
                    <div class="navbar">
                      <span class="navbar-padding">
                        <mf-icon>notifications_none</mf-icon>
                      </span>
                    </div>
                    <div class="box-offers-placeholder"></div>
                    <div :class="['box-banner'].concat(hasBanner ? [] : ['empty-banner'])">
                      <img v-if="hasBanner" :src="configuration.banner" class="responsive-image" />
                      <mf-image-cropper
                        v-show="!hasBanner"
                        ref="imageCropper"
                        :mb-size-limit="10"
                        :upload-image="modifyBanner"
                        url=""
                        :width="720"
                        :height="300"
                      />
                    </div>
                    <div class="box-buttons-group">
                      <div class="box-button-placeholder first-button"></div>
                      <div class="box-button-placeholder second-button"></div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </div>
          </v-row>
          <mf-action-buttons
            v-if="hasBanner"
            :primary-button="{
              text: 'Alterar',
              action: () => ($refs.imageCropper.isOpen = true),
              isVisible: true,
            }"
            :extra-button="{
              text: 'Remover',
              action: removeBanner,
              isVisible: true,
            }"
          />
        </v-card>
      </v-container>
    </mf-loading-dialog>
  </div>
</template>

<script>
import gql from 'graphql-tag'

const QUERY_CONFIGURATION = gql`
  query AppConfiguration {
    configuration: appConfiguration {
      banner
    }
  }
`

const UPLOAD_BANNER = gql`
  mutation UploadBanner($base64: String!) {
    updateBanner(base64: $base64) {
      url
    }
  }
`

const REMOVE_BANNER = gql`
  mutation RemoveBanner {
    removeBanner
  }
`

export default {
  computed: {
    hasBanner() {
      return Boolean(this.configuration && this.configuration.banner)
    },
  },
  apollo: {
    configuration: {
      query: QUERY_CONFIGURATION,
    },
  },
  mounted() {
    document.title = 'Banner'
  },
  methods: {
    async modifyBanner({ base64 }) {
      let confirmed = true
      if (this.hasBanner) {
        confirmed = await this.$confirm({
          title: 'Substituir banner',
          message: 'Tem certeza que deseja substituir o banner atual?',
          confirmColor: 'success',
          confirmText: 'Salvar',
          cancelText: 'Cancelar',
        })
          .then(() => true)
          .catch(() => false)
      }
      if (confirmed) {
        await this.$apollo.mutate({
          mutation: UPLOAD_BANNER,
          variables: { base64 },
        })
        this.$apollo.queries.configuration.refetch()
      }
      return confirmed
    },
    async removeBanner() {
      await this.$confirm({
        title: 'Remover banner',
        message: 'Tem certeza que deseja remover o banner?',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          await this.$apollo.mutate({
            mutation: REMOVE_BANNER,
          })
          this.$apollo.queries.configuration.refetch()
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss">
$phone-size: 600px;
$tablet-size: 960px;

.buttons-row {
  padding: 5px 30px 5px 30px;
}

.configurar-banner {
  width: 546px;
  p,
  span {
    max-width: inherit;
    max-height: inherit;
    word-wrap: break-word;
  }
  .outer-frame-push {
    border: 2px solid $cinza-l80;
    border-radius: 40px 40px 0 0;
    border-bottom: 0;
    @media screen and (max-width: $tablet-size) {
      padding: 4vh 3vw;
      margin: 2vh 3vw;
    }
    @media screen and (min-width: $tablet-size) {
      margin: 2vh 3vw 0;
      padding: 4vh 3vw 0;
    }
    height: 49vh;
    .camera-slot {
      border: 2px solid $cinza-l80;
      border-radius: 20px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 2vh;
      margin-right: 0.8vw;
    }
    .ear-speaker-slot {
      border: 2px solid $cinza-l80;
      border-radius: 30px;
      display: inline-block;
      margin-bottom: 5vh;
      height: 2vh;
      width: 10vw;
      margin-left: 0.8vw;
    }
    .inner-frame-mobile {
      border: 2px solid $cinza-l80;
      border-bottom: 0;
      height: 38vh;
      max-height: 38vh;
      overflow: none;
      .navbar {
        display: flex;
        flex-direction: row-reverse;
        background-color: $cinza-l90;
        padding: 1.6vw;
        .navbar-padding {
          display: inline-block;
        }
      }
      .box-offers-placeholder {
        border-radius: 0 0 10px 10px;
        border: 1.5px solid $cinza-l80;
        height: 1vh;
        margin: 0 1.5vh 0 1.5vh;
        border-top: 0;
      }
      .box-banner {
        height: 140px;
        margin: 2vh;
        justify-content: center;
        align-items: center;
        display: flex;
      }
      .empty-banner {
        border: 1.5px solid $cinza-l80;
      }
      .box-buttons-group {
        flex-direction: row;
        display: flex;
        .box-button-placeholder {
          border-radius: 10px 10px 0 0;
          border: 1.5px solid $cinza-l80;
          border-bottom: 0;
          height: 1.5vh;
          width: 30vh;
          margin: 0 2vh 0 2vh;
        }
        .first-button {
          margin-right: 0;
        }
      }
    }
  }
}
</style>
